import { REFUNDABLE_AIRPORT_LIST } from '@repo/constants';
import { AIRPORT_VALUE } from '@repo/types';
import html2canvas from 'html2canvas';

export function CalculateBox(
  targetArr: [number, number?, number?, number?],
): string {
  let resultArr: [number, number, number, number] = [
    targetArr[0],
    targetArr[0],
    targetArr[0],
    targetArr[0],
  ];

  if (targetArr.length === 2) {
    if (targetArr[1] !== undefined)
      resultArr = [targetArr[0], targetArr[1], targetArr[0], targetArr[1]];
  } else if (targetArr.length === 3) {
    if (targetArr[1] !== undefined && targetArr[2] !== undefined)
      resultArr = [targetArr[0], targetArr[1], targetArr[2], targetArr[1]];
  } else if (targetArr.length === 4) {
    if (
      targetArr[1] !== undefined &&
      targetArr[2] !== undefined &&
      targetArr[3] !== undefined
    )
      resultArr = [targetArr[0], targetArr[1], targetArr[2], targetArr[3]];
  }

  return `${resultArr.toString().replace(/,/gi, 'px ')}px`;
}
export const addComma = (num: string | number) => {
  if (!num) {
    return '0';
  }
  return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getDday = (date: string) => {
  const today = new Date();
  const selectedDay = new Date(date);
  //시간-분 단위를 0으로 만들기 위한 작업(시간-분 단위가 없어야 디데이 계산이 정확함)
  today.setHours(0, 0, 0, 0);
  selectedDay.setHours(0, 0, 0, 0);
  const diff = selectedDay.getTime() - today.getTime();
  const result = diff / (1000 * 60 * 60 * 24);

  if (result > 0) {
    return `D-${result}`;
  } else if (result === 0) {
    return 'D-DAY';
  } else {
    return 'Completed';
  }
};

export const isBusinessTime = (date: Date) => {
  const hours = date.getHours();
  const day = date.getDay();
  const isBusinessDay = day !== 0 && day !== 6;
  const isBusinessTime = 8 <= hours && hours <= 17;
  return isBusinessDay && isBusinessTime;
};

export const getKorDate = () => {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60 * 1000;
  const koreaTimeDiff = 9 * 60 * 60 * 1000;
  const korNow = new Date(utc + koreaTimeDiff);
  return korNow;
};

export const convertComponentToImage = async (el: HTMLElement) => {
  const canvas = await html2canvas(el);
  return canvas.toDataURL('image/png', 1.0);
};

export const dataURItoBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ab], { type: mimeString });
};

export const getProductType = (num: number) => {
  switch (num) {
    case 0:
      return '쌍커풀 수술';
    case 1:
      return '코 성형 수술';
    case 2:
      return '유방 수술';
    case 3:
      return '지방 흡입술';
    case 4:
      return '주름살 제거술';
    case 5:
      return '안면 윤곽술';
    case 6:
      return '치아 성형술';
    case 7:
      return '악안면 교정술';
    case 8:
      return '색소 모반/주근깨/흑색점/기미 치료술';
    case 9:
      return '여드름 치료술';
    case 10:
      return '제모술';
    case 11:
      return '탈모 치료/모발이식술';
    case 12:
      return '문신/문신 제거/피어싱';
    case 13:
      return '지방융해술';
    case 14:
      return '피부재생/미백/항노화치료/모공 축소술';
    case 15:
      return '기타';
  }
};
// 생일 1993-05-11 형식
export const attachedHyphensDate = (dateNumber: string) => {
  return dateNumber
    .replace(/[^0-9]/g, '')
    .replace(/^(\d{0,4})(\d{0,2})(\d{0,2})/g, '$1-$2-$3')
    .replace(/(\-{1,2})$/g, '');
};
// 우편번호 000-0000 형식
export const attachedHyphensPostCode = (dateNumber: string) => {
  return dateNumber
    .replace(/[^0-9]/g, '')
    .replace(/^(\d{3})(\d{0,4})/, '$1-$2')
    .replace(/(\-{1,2})$/g, '');
};
export const isNationIncluded = (
  list: string[],
  targetNation: string,
): boolean => {
  return list.includes(targetNation);
};

export const sanitizeInput = (value: string) => {
  return value.replace(/[^a-zA-Z0-9 ]/g, '');
};

export const isRefundableAirport = (airport: string | null) => {
  if (!airport) return false;
  return REFUNDABLE_AIRPORT_LIST.includes(airport as AIRPORT_VALUE);
};
